import { render, staticRenderFns } from "./list_h5.vue?vue&type=template&id=57bab57f&scoped=true&"
import script from "./list_h5.vue?vue&type=script&lang=js&"
export * from "./list_h5.vue?vue&type=script&lang=js&"
import style0 from "./list_h5.vue?vue&type=style&index=0&id=57bab57f&lang=less&scoped=true&"
import style1 from "./list_h5.vue?vue&type=style&index=1&id=57bab57f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bab57f",
  null
  
)

export default component.exports